export default __webpack_public_path__ + "static/akmoor-a6dc15bd571af548c7c9f6a57ac2c0c8.jpg";